import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    CustomInput,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText, Tooltip
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ImageGallery from '../../views/app/pages/propinfo/gallery/index';
import { Colxx } from '../../components/common/CustomBootstrap';
import timeZoneOptions from '../../data/timeZone';
import currencies from '../../data/currencies';
import { AxiosAPI } from '../../helpers/AxiosAPI';
import { gAPI_Internal_Property_By_Id, postAPI_Update_Property } from '../../constants/APIs';
import Select from 'react-select';
import country from '../../data/country';
import { reactSelectOptionDiffrentPro } from '../../helpers/Utils';
import timeZoneList from '../../data/timeZoneList';
import currencyList from '../../data/currencyList';
import moment from 'moment';
import { NotificationManager } from '../../components/common/react-notifications';

export function BusinessProfile({
    visible,
    toggle,
    groupId,
    propertyId
}) {
    const [selectedCountry, setSelectedCountry] = useState({
        value: '',
        label: 'Please Select',
    });
    const [selectZones, setSelectZones] = useState();
    const [startDate, setStartDate] = useState(null);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [propertyData, setpropertyData] = useState({
        groupId: groupId,
        type: 'hotel',
        name: '',
        currency: 'NZD',
        inventoryProvider: 'None',
        ratesProvider: 'None',
        bookingProvider: 'None',
        timeZone: 'None',
        ariUrl: '',
        bookingUrl: '',
        creator: 'Manually',
        isTemplate: false,
        displayOrder: 1,
        country: 'NZ',
        status: 'Active',
        websiteLink: '',
        rooms: 0,
        starRating: 0,
        images: 'https://via.placeholder.com/150/',
        bmbAccountManager: '',
        bmbVoucherProcessingFee: 0,
        customerSuccessManager: '',
        isBmb: false,
        isAiva: false,
        isVirtualFrontDesk: false,
        isRateBooking: false,
        activationDate: null,
        redeemAddress: '',
        averageDailyRate: 0,
        legalBusinessName: '',
        businessAddress: '',
    }
    );
    const [tooltipOpen, setTooltipOpen] = useState(false);
    useEffect(() => {
        if (propertyId !== undefined && propertyId !== "-1") {
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${groupId}`,
            })
                .then((res) => {
                    setStartDate(moment(res.data.activationDate).format('MMM DD, YYYY') === 'Jan 01, 0001' ? null
                        : moment(res.data.activationDate));
                    setpropertyData(res.data);
                    // let currency = currencyList.filter(item => item.countryCode === res.data.country);
                    let timeZones = timeZoneList.filter(
                        (item) => item.IsoAlpha2 === res.data.country
                    );
                    const countryGroup = country.filter(
                        (item) => item.code === res.data.country
                    );
                    let countrySelected = {
                        value: countryGroup[0].code,
                        label: countryGroup[0].name,
                    };
                    setSelectedCountry(countrySelected);
                    // setpropertyData({
                    //     ...propertyData,
                    //     country: value.value,
                    //     currency: currency[0].currencyCode
                    // });

                    setSelectZones(
                        timeZones[0].TimeZones.map((zone) => {
                            return <option key={zone} value={zone}>{zone}</option>;
                        })
                    );
                })
                .catch((err) => console.log('err', err));
        }
    }, [propertyId]);
    const handleChange = (e) => {
        setpropertyData({
            ...propertyData,
            [e.target.name]: e.target.value,
        });
    };
    const handleRateChange = (e) => {
        setpropertyData({
            ...propertyData,
            starRating: e.rating,
        });
    };
    const handleCheckedChange = (e) => {
        setpropertyData({
            ...propertyData,
            [e.target.name]: e.currentTarget.checked,
        });
    };
    const togglegallery = () => {
        // setImageIndex(index);
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setpropertyData({
            ...propertyData,
            images: image.src,
        });
    };

    //console.log(startDate);
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>
                                    Select Image or Upload New Image
                                </ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={''}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    const handleChangeSelect = (value, { name }) => {
        let currency = currencyList.filter(
            (item) => item.countryCode === value.value
        );
        let timeZones = timeZoneList.filter(
            (item) => item.IsoAlpha2 === value.value
        );
        setpropertyData({
            ...propertyData,
            country: value.value,
            currency: currency[0].currencyCode,
            timeZone: timeZones[0].TimeZones[0],
        });
        setSelectedCountry(value);
        setSelectZones(
            timeZones[0].TimeZones.map((zone) => {
                return <option value={zone}>{zone}</option>;
            })
        );
    };

    const handleSubmit = () => {
        const formmatedData = { ...propertyData, updater: 'admin' };
        AxiosAPI({
            method: 'put',
            url: `${postAPI_Update_Property}/${propertyId}`,
            data: formmatedData,
        }).then(() => {
            NotificationManager.success(
                "",
                "Profile update successfully",
                3000,
                null,
                null,
                "success"
            );
            toggle();
        });
    };

    const selectTimeZoneOptions = timeZoneOptions
        .sort(dynamicSort('label'))
        .map((item) => {
            return <option value={item.value}>{item.label}</option>;
        });

    const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
        return <option value={item.value}>{item.label}</option>;
    });

    function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === '-') {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers,
             * and you may want to customize it to your needs
             */
            var result =
                a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
            return result * sortOrder;
        };
    }
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>Bussiness Profile</ModalHeader>
                <ModalBody>
                    <Row className="">
                        <Colxx xxs="12">
                            <Row>
                                <Colxx sm={12} className="mb-3">
                                    <Label>Bussiness Name <i className="demo-icon simple-icon-info" id="titletip"></i></Label>
                                    <Tooltip
                                        placement="right"
                                        isOpen={tooltipOpen}
                                        target="titletip"
                                        toggle={() => setTooltipOpen(!tooltipOpen)}
                                    >
                                        A short title which will appear when users ask about the bussiness profile
                                    </Tooltip>
                                    <Input
                                        type="text"
                                        value={propertyData.name}
                                        onChange={handleChange}
                                        name="name"
                                    />
                                </Colxx>
                                <Colxx sm={12} className="mb-3">
                                    <Label>Bussiness Website</Label>
                                    <Input
                                        type="text"
                                        value={propertyData.websiteLink}
                                        onChange={handleChange}
                                        name="websiteLink"
                                    />
                                </Colxx>
                                <Colxx sm={12} className="mb-3">
                                    <Label>Bussiness Type</Label>
                                    <Input
                                        type="select"
                                        value={propertyData.type}
                                        name="type"
                                        onChange={handleChange}
                                    >
                                        <option value="CampGround">CampGround</option>
                                        <option value="Hostel">Hostel</option>
                                        <option value="Hotel">Hotel</option>
                                        <option value="Lodge">Lodge</option>
                                        <option value="Motel">Motel</option>
                                        <option value="Bach">Other Business Operator</option>
                                        <option value="Pub">Pub</option>
                                        <option value="Resort">Resort</option>

                                    </Input>
                                </Colxx>
                                <Colxx sm={6} className="mb-3">
                                    <Label>Country</Label>
                                    <Select
                                        isMulti={false}
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        name="code"
                                        placeholder="Select Country"
                                        onChange={handleChangeSelect}
                                        value={selectedCountry}
                                        options={
                                            country
                                                ? reactSelectOptionDiffrentPro(
                                                    country,
                                                    true,
                                                    'code',
                                                    'name',
                                                    ''
                                                )
                                                : []
                                        }
                                    />
                                </Colxx>
                                {selectZones !== undefined && selectZones.length > 0 && (
                                    <Colxx sm={6} className="mb-3">
                                        <Label>Time Zone</Label>
                                        <Input
                                            type="select"
                                            value={propertyData.timeZone}
                                            name="timeZone"
                                            onChange={handleChange}
                                        >
                                            {selectZones}
                                        </Input>
                                    </Colxx>
                                )}
                                <Colxx sm={12} className="mb-3">
                                    <Label>Legal Business Name</Label>
                                    <Input
                                        type="text"
                                        value={propertyData.legalBusinessName}
                                        name="legalBusinessName"
                                        onChange={handleChange}
                                    >
                                    </Input>
                                </Colxx>
                                <Colxx sm={12} className="mb-3">
                                    <Label>Business Address</Label>
                                    <Input
                                        type="text"
                                        value={propertyData.businessAddress}
                                        name="businessAddress"
                                        onChange={handleChange}
                                    >
                                    </Input>
                                </Colxx>
                            </Row>
                        </Colxx>

                        <Fragment>
                            <Colxx sm={12}>
                                <h4>Logo</h4>
                            </Colxx>
                            <Colxx sm={12}>
                                <Row>
                                    <Colxx sm={2} className="md-3">
                                        <img
                                            style={{
                                                width: '100%',
                                                height: '90%',
                                            }}
                                            alt="room image"
                                            src={
                                                propertyData.images || 'https://via.placeholder.com/150/'
                                            }
                                        />
                                    </Colxx>
                                    <Colxx sm={1} className="mb-3">
                                        <Label>Browse</Label>
                                        <div
                                            className="iconsminds-photo"
                                            onClick={(event) => togglegallery()}
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '28px',
                                                color: '#73236b',
                                            }}
                                        ></div>
                                    </Colxx>
                                </Row>
                            </Colxx>
                        </Fragment>
                    </Row>
                    {ImageGalleryButton()}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Save
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}
